
import { useAdmin } from "./admin";
import { usePlayer } from "./player";

export function useExtAdminTwar(props) {
    const admin = useAdmin();
    const crusade = admin.crusade;

    function editMatchField(id, field, value) {
        admin.call('admin/twar/crusade/' + crusade.id + '/match/' + id + '/edit/' + field, value)
    }

    return {
        crusade: crusade,
        alliances: crusade.alliances,

        reload: admin.reload,

        editMatchField,
    }
}
export function useExtTwar(props) {
    const player = usePlayer()
    const crusade = player.crusade;

    function joinAlliance(allianceId) {
        player.call('twar/alliance/' + allianceId + '/join')
    }

    return {
        crusade: crusade,
        alliances: crusade.alliances,

        joinAlliance,

        reload: player.reload,
    }
}
